import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { alphaSort } from '../../../../common/utils'
import { i18n } from '../../../index'
import ChainSettingsRow from './ChainSettingsRow'
import css from './chainSettingsTable.css'

export default class ChainSettingsTable extends React.PureComponent<any, any> {
  render() {
    const { data } = this.props
    return (
      <React.Fragment>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={css.tableHeading}>{i18n.t('admin.chainSettings.settingName')}</TableCell>
              <TableCell className={css.tableHeading}>{i18n.t('admin.chainSettings.settingValue')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length ? (
              alphaSort('name', data).map((setting: any) => <ChainSettingsRow data={setting} key={setting.id} />)
            ) : (
              <TableRow>
                <TableCell>{i18n.t('admin.vitrineProducts.products.noProducts')}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </React.Fragment>
    )
  }
}
